import React, { useState, useRef } from 'react';
import { Gift, Mail, Phone, Snowflake, TreePine, Star, Info, Users, CalendarDays, Send, CheckCircle2, AlertCircle, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const dietLabel = (codes) => codes;

const menus = [
  {
    id: 'tontun-suosikit',
    title: 'Tontun',
    script: 'suosikit',
    price: '53,50',
    featured: true,
    sections: [
      {
        items: [
          { name: 'Viherversosalaattia kurkulla, karpaloilla ja paahdetuilla siemenillä', diet: 'M, G' },
          { name: 'Rosollia & vuohenjuustovaahtoa', diet: 'L, G' },
          { name: 'Jouluinen taateli-coleslaw', diet: 'L, G' },
          { name: 'Waldorfin salaatti', diet: 'L, G' },
          { name: 'Lasimestarin silliä', diet: 'M, G' },
          { name: 'Keitinperunat tillivoilla', diet: 'L, G' },
        ],
      },
      {
        items: [
          { name: 'Uunijuurekset appelsiini-rosmariinisiirapilla', diet: 'M, G' },
          { name: 'Sinihome-piparipunajuuria', diet: 'L, G' },
          { name: 'Perunagratiinia', diet: 'L, G' },
          { name: 'Ylikypsää häränrintaa & karpalokastiketta', diet: 'M, G' },
        ],
      },
      {
        items: [
          { name: 'Datan saaristolaisleipää, talon leipää & tuorejuustolevite', diet: 'L' },
        ],
      },
      {
        items: [
          { name: 'Piparkakkutrifleä', diet: 'L' },
          { name: 'Kahvi & tee', diet: '' },
        ],
      },
    ],
  },
  {
    id: 'joulun-makuja',
    title: 'Joulun',
    script: 'makuja',
    price: '39,50',
    sections: [
      {
        items: [
          { name: 'Viherversosalaatti & viikunavinaigrette', diet: 'M, G' },
          { name: 'Persimoni-halloumisalaatti', diet: 'L, G' },
          { name: 'Metsäsienisalaatti', diet: 'L, G' },
          { name: 'Keltaista rosollia & sahramikastike', diet: 'M, G sekä L, G' },
          { name: 'Punajuurigraavattu lohi', diet: 'M, G' },
          { name: 'Smetanasilliä', diet: 'L, G' },
          { name: 'Keitinperunat tillivoilla', diet: 'L, G' },
        ],
      },
      {
        items: [
          { name: 'Rosmariini-appelsiinikanaa TAI kinkku & luumukastike', diet: 'L, G' },
          { name: 'Datan konjakkisinappi', diet: 'M, G' },
          { name: 'Porkkanalaatikko inkiväärillä maustettuna', diet: 'L, G' },
          { name: 'Chili-bataattilaatikko', diet: 'L, G' },
          { name: 'Siirappiset kermaperunat', diet: 'L, G' },
        ],
      },
      {
        items: [
          { name: 'Maalaisleipää, Datan saaristolaisleipää & paahdettua voita', diet: 'L' },
        ],
      },
      {
        items: [
          { name: 'Jouluinen pannacotta', diet: 'L, G' },
          { name: 'Kahvi & tee', diet: '' },
        ],
      },
    ],
  },
  {
    id: 'kuusen-katveessa',
    title: 'Kuusen',
    script: 'katveessa',
    price: '31,50',
    sections: [
      {
        items: [
          { name: 'Vihersalaattia paahdetuilla päärynöillä & karpaloilla', diet: 'M, G' },
          { name: 'Rosollia & kastiketta', diet: 'M, G ja L, G' },
          { name: 'Metsäsienisalaattia', diet: 'L, G' },
          { name: 'Kolmen sipulin silliä', diet: 'M, G' },
          { name: 'Mustaherukkasilliä', diet: 'M, G' },
          { name: 'Keitinperunat tillivoilla', diet: 'L, G' },
        ],
      },
      {
        items: [
          { name: 'Kinkku & kermakastike', diet: 'L, G' },
          { name: 'Datan konjakkisinappi', diet: 'M, G' },
          { name: 'Porkkanalaatikko', diet: 'L, G' },
          { name: 'Lanttulaatikko', diet: 'L, G' },
          { name: 'Imelletty perunalaatikko', diet: 'L' },
        ],
      },
      {
        items: [
          { name: 'Maalaisleipä & levite', diet: 'L' },
          { name: 'Datan saaristolaisleipä & levite', diet: 'L' },
        ],
      },
      {
        items: [
          { name: 'Joulutorttu', diet: 'L' },
          { name: 'Kahvi & tee', diet: '' },
        ],
      },
    ],
  },
  {
    id: 'joulupukin-herkkupoyta',
    title: 'Joulupukin',
    script: 'herkkupöytä',
    price: '31,50',
    sections: [
      {
        items: [
          { name: 'Rapsakkaa salaattia melonilla, rypäleillä & sitrusvinaigrette', diet: 'M, G' },
          { name: 'Keksejä & paahdettua briejuustoa pähkinöillä & vaahterasiirapilla', diet: 'L' },
          { name: 'Rosmariinivoissa paistettua kanafileetä', diet: 'M, G' },
          { name: 'Chorizomakkaraa & karpalo-punasipulihilloketta', diet: 'M, G' },
          { name: 'Saaristolaisleipää lohicevichellä & sienimoussella', diet: 'L' },
          { name: 'Päärynä-aurajuustomoussekakkua', diet: 'L' },
          { name: 'Kahvi & tee', diet: '' },
        ],
      },
    ],
  },
];

const MenuCard = ({ menu, onOrder }) => (
  <div
    data-testid={`xmas-menu-${menu.id}`}
    className={`relative bg-white rounded-3xl border-2 shadow-sm overflow-hidden flex flex-col ${
      menu.featured ? 'border-red-300' : 'border-emerald-200'
    }`}
  >
    {menu.featured && (
      <div className="absolute top-4 right-4 bg-red-600 text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full flex items-center gap-1">
        <Star className="w-3 h-3" /> Suosituin
      </div>
    )}
    <div className={`px-8 pt-8 pb-6 text-center ${menu.featured ? 'bg-gradient-to-b from-red-50 to-white' : 'bg-gradient-to-b from-emerald-50 to-white'}`}>
      <TreePine className={`w-7 h-7 mx-auto mb-3 ${menu.featured ? 'text-red-500' : 'text-emerald-600'}`} />
      <h2 className={`text-3xl font-bold uppercase tracking-wide ${menu.featured ? 'text-red-600' : 'text-emerald-700'}`}>
        {menu.title}
      </h2>
      <p className="font-handwritten text-4xl text-stone-700 -mt-1">{menu.script}</p>
    </div>
    <div className="px-8 pb-6 flex-1">
      {menu.sections.map((section, i) => (
        <div key={i} className={i > 0 ? 'mt-5 pt-5 border-t border-dashed border-stone-200' : ''}>
          <ul className="space-y-2">
            {section.items.map((item, j) => (
              <li key={j} className="text-stone-700 text-sm md:text-base leading-snug text-center">
                {item.name}
                {item.diet && (
                  <span className="ml-1.5 text-xs font-semibold text-emerald-600 whitespace-nowrap">
                    {dietLabel(item.diet)}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className={`px-8 py-5 text-center ${menu.featured ? 'bg-red-50' : 'bg-emerald-50'}`}>
      <span className={`text-3xl font-bold ${menu.featured ? 'text-red-600' : 'text-emerald-700'}`}>
        {menu.price}€
      </span>
      <span className="text-stone-500 text-sm ml-1">/hlö</span>
      <button
        onClick={() => onOrder(menu.id)}
        data-testid={`order-btn-${menu.id}`}
        className={`mt-3 w-full inline-flex items-center justify-center gap-2 text-white px-5 py-2.5 rounded-full font-medium transition-colors ${
          menu.featured ? 'bg-red-600 hover:bg-red-700' : 'bg-emerald-600 hover:bg-emerald-700'
        }`}
      >
        <Gift className="w-4 h-4" />
        Tilaa tämä menu
      </button>
    </div>
  </div>
);

export default function PikkujoulutPage() {
  const formRef = useRef(null);
  const [formData, setFormData] = useState({
    menuId: '',
    guestCount: '',
    eventDate: '',
    name: '',
    email: '',
    phone: '',
    notes: '',
  });
  const [status, setStatus] = useState('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const selectedMenu = menus.find((m) => m.id === formData.menuId);
  const menuName = selectedMenu ? `${selectedMenu.title} ${selectedMenu.script}` : '';
  const priceNum = selectedMenu ? parseFloat(selectedMenu.price.replace(',', '.')) : 0;
  const count = parseInt(formData.guestCount, 10) || 0;
  const estimatedTotal = priceNum && count ? (priceNum * count).toFixed(2).replace('.', ',') : null;

  const handleOrderClick = (menuId) => {
    setFormData((prev) => ({ ...prev, menuId }));
    formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setErrorMsg('');
    try {
      const res = await fetch(`${API_BASE}/api/xmas-order`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name.trim(),
          email: formData.email.trim(),
          phone: formData.phone.trim() || null,
          menu: `${menuName} (${selectedMenu.price}€/hlö)`,
          guest_count: count,
          event_date: formData.eventDate,
          estimated_total: estimatedTotal ? `${estimatedTotal}€` : null,
          extra_notes: formData.notes.trim() || null,
        }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.detail || `Virhe (${res.status})`);
      }
      setStatus('success');
    } catch (err) {
      setStatus('error');
      setErrorMsg(err.message || 'Lähetys epäonnistui. Yritä uudelleen.');
    }
  };

  const isSending = status === 'sending';

  return (
    <div className="min-h-screen bg-gradient-to-b from-red-50/60 via-white to-emerald-50">
      {/* Hero */}
      <section className="relative py-20 md:py-28 bg-gradient-to-br from-red-900 via-stone-900 to-emerald-950 overflow-hidden">
        <Snowflake className="absolute top-10 left-10 w-20 h-20 text-white/10" />
        <Snowflake className="absolute bottom-10 right-16 w-32 h-32 text-white/10" />
        <TreePine className="absolute top-1/2 right-8 w-24 h-24 text-emerald-500/10" />
        <div className="relative max-w-7xl mx-auto px-6 text-center">
          <span className="font-handwritten text-4xl text-red-300 block mb-2">Juhlakausi lähestyy!</span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-4">Pikkujoulumenut</h1>
          <p className="text-lg text-stone-300 max-w-2xl mx-auto">
            Neljä jouluista menukokonaisuutta pikkujouluihin ja joulun juhliin.
          </p>
        </div>
      </section>

      {/* Diet legend */}
      <section className="bg-emerald-500 text-white py-3">
        <div className="max-w-7xl mx-auto px-6 flex flex-wrap justify-center items-center gap-x-6 gap-y-1 text-sm">
          <span className="flex items-center gap-1.5"><Info className="w-4 h-4" /> Merkinnät:</span>
          <span><strong>M</strong> = maidoton</span>
          <span><strong>L</strong> = laktoositon</span>
          <span><strong>G</strong> = gluteeniton</span>
        </div>
      </section>

      {/* Menu cards */}
      <section className="py-14 md:py-20">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-8">
          {menus.map((menu) => (
            <MenuCard key={menu.id} menu={menu} onOrder={handleOrderClick} />
          ))}
        </div>
      </section>

      {/* Order form */}
      <section ref={formRef} className="pb-16 scroll-mt-24" data-testid="xmas-order-form-section">
        <div className="max-w-3xl mx-auto px-6">
          <div className="bg-white rounded-3xl border-2 border-red-200 shadow-sm p-6 md:p-10">
            <div className="text-center mb-8">
              <span className="font-handwritten text-3xl text-red-500 block mb-1">Tilaa pikkujouluherkut</span>
              <h2 className="text-2xl md:text-3xl font-bold text-stone-800">Tilauslomake</h2>
            </div>

            {status === 'success' ? (
              <div className="text-center py-8" data-testid="xmas-form-success">
                <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto mb-4" />
                <h3 className="text-xl font-bold text-stone-800 mb-2">Kiitos tilauksestasi!</h3>
                <p className="text-stone-600 mb-6">
                  Olemme sinuun yhteydessä mahdollisimman pian tilauksen vahvistamiseksi.
                </p>
                <Button
                  onClick={() => {
                    setStatus('idle');
                    setFormData({ menuId: '', guestCount: '', eventDate: '', name: '', email: '', phone: '', notes: '' });
                  }}
                  variant="outline"
                  className="rounded-xl"
                  data-testid="xmas-form-new-order"
                >
                  Tee uusi tilaus
                </Button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-sm font-medium text-stone-700 mb-1.5">Valitse menu *</label>
                  <select
                    name="menuId"
                    value={formData.menuId}
                    onChange={handleChange}
                    required
                    data-testid="xmas-form-menu-select"
                    className="w-full h-10 px-3 rounded-md border border-input bg-white text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
                  >
                    <option value="" disabled>Valitse menu...</option>
                    {menus.map((m) => (
                      <option key={m.id} value={m.id}>
                        {m.title} {m.script} — {m.price}€/hlö
                      </option>
                    ))}
                  </select>
                </div>

                <div className="grid sm:grid-cols-2 gap-5">
                  <div>
                    <label className="block text-sm font-medium text-stone-700 mb-1.5">
                      <Users className="w-4 h-4 inline mr-1 -mt-0.5" />
                      Henkilömäärä *
                    </label>
                    <Input
                      type="number"
                      name="guestCount"
                      min="1"
                      max="2000"
                      value={formData.guestCount}
                      onChange={handleChange}
                      required
                      placeholder="esim. 25"
                      data-testid="xmas-form-guest-count"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-stone-700 mb-1.5">
                      <CalendarDays className="w-4 h-4 inline mr-1 -mt-0.5" />
                      Tilaisuuden päivämäärä *
                    </label>
                    <Input
                      type="date"
                      name="eventDate"
                      value={formData.eventDate}
                      onChange={handleChange}
                      required
                      data-testid="xmas-form-date"
                    />
                  </div>
                </div>

                {estimatedTotal && (
                  <div className="bg-emerald-50 border border-emerald-200 rounded-xl px-4 py-3 text-center" data-testid="xmas-form-estimate">
                    <span className="text-sm text-stone-600">Arvioitu hinta: </span>
                    <span className="text-lg font-bold text-emerald-700">{estimatedTotal}€</span>
                    <span className="text-xs text-stone-500 ml-1">({count} hlö × {selectedMenu.price}€)</span>
                  </div>
                )}

                <div className="grid sm:grid-cols-2 gap-5">
                  <div>
                    <label className="block text-sm font-medium text-stone-700 mb-1.5">Nimi *</label>
                    <Input
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Etunimi Sukunimi"
                      data-testid="xmas-form-name"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-stone-700 mb-1.5">Puhelin</label>
                    <Input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="040 123 4567"
                      data-testid="xmas-form-phone"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-stone-700 mb-1.5">Sähköposti *</label>
                  <Input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="nimi@esimerkki.fi"
                    data-testid="xmas-form-email"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-stone-700 mb-1.5">Lisätiedot</label>
                  <Textarea
                    name="notes"
                    value={formData.notes}
                    onChange={handleChange}
                    rows={4}
                    placeholder="Esim. allergiat, toimitusosoite, toiveet..."
                    data-testid="xmas-form-notes"
                  />
                </div>

                {status === 'error' && (
                  <div className="flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 rounded-xl px-4 py-3 text-sm" data-testid="xmas-form-error">
                    <AlertCircle className="w-4 h-4 shrink-0" />
                    {errorMsg}
                  </div>
                )}

                <Button
                  type="submit"
                  disabled={isSending}
                  data-testid="xmas-form-submit"
                  className="w-full bg-red-600 hover:bg-red-700 text-white py-3 rounded-xl text-base"
                >
                  {isSending ? (
                    <>
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                      Lähetetään...
                    </>
                  ) : (
                    <>
                      <Send className="w-4 h-4 mr-2" />
                      Lähetä tilaus
                    </>
                  )}
                </Button>
                <p className="text-xs text-stone-500 text-center">
                  Tilaus ei ole vielä sitova — vahvistamme tilauksen sähköpostitse tai puhelimitse.
                </p>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* Order CTA */}
      <section className="pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <div className="bg-stone-900 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden">
            <Gift className="absolute -top-4 -left-4 w-28 h-28 text-white/5" />
            <Snowflake className="absolute -bottom-6 -right-6 w-32 h-32 text-white/5" />
            <span className="font-handwritten text-3xl text-red-300 block mb-2">Tilaa omat pikkujouluherkut</span>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-6">Tilaukset:</h2>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="mailto:info@datalounas.com"
                data-testid="xmas-order-email"
                className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white px-6 py-3 rounded-full font-medium transition-colors"
              >
                <Mail className="w-5 h-5" />
                info@datalounas.com
              </a>
              <a
                href="tel:0449783049"
                data-testid="xmas-order-phone"
                className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-6 py-3 rounded-full font-medium transition-colors border border-white/20"
              >
                <Phone className="w-5 h-5" />
                044 9783049
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
